import BankAccount from '@/modules/adjusterReportModules/Insurer-information/pages/bank-account/BankAccount';
import EditBodyBankAccount from '@/modules/adjusterReportModules/Insurer-information/components/bankAccount/bankAccount/EditBankAccount';
import ShowBodyBankAccount from '@/modules/adjusterReportModules/Insurer-information/components/bankAccount/showBankAccount/ShowBankAccount';
import BodyInsuranceInsurance from '@/modules/adjusterReportModules/Insurer-information/pages/body-insurance/BodyInsuranceInsurance';
import EditBodyInsurance from '@/modules/adjusterReportModules/Insurer-information/components/bodyInsurance/editBodyInsurance/EditBodyInsurance';
import ShowBodyInsurance from '@/modules/adjusterReportModules/Insurer-information/components/bodyInsurance/showBodyInsurance/ShowBodyInsurance';
import BodyCertificateInformation from '@/modules/adjusterReportModules/Insurer-information/components/owner/driver/BodyCertificateInformation';
import BodyContactInfo from '@/modules/adjusterReportModules/Insurer-information/components/owner/driver/BodyContactInfo';
import BodyInitialDataDriver from '@/modules/adjusterReportModules/Insurer-information/components/owner/driver/BodyInitialDataDriver';
import { BodyOwnerContract } from '@/modules/adjusterReportModules/Insurer-information/components/owner/owner/contract/BodyOwnerContract';
import { BodyOwnerUserInformation } from '@/modules/adjusterReportModules/Insurer-information/components/owner/owner/user-information/BodyOwnerUserInformation';
import BodyDriverInfo from '@/modules/adjusterReportModules/Insurer-information/pages/driver-owner/driverInfo/BodyDriverInfo';
import BodyOwnerInfo from '@/modules/adjusterReportModules/Insurer-information/pages/driver-owner/ownerInfo/BodyOwnerInfo';
import ShowBodyDriverOwnerData from '@/modules/adjusterReportModules/Insurer-information/pages/driver-owner/showBodyDriverOwnerData/ShowBodyDriverOwnerData';
import BodyPartOne from '@/modules/adjusterReportModules/Insurer-information/components/vehicleInformation/components/bodyPartOne/BodyPartOne';
import BodyPartTwo from '@/modules/adjusterReportModules/Insurer-information/components/vehicleInformation/components/bodyPartTwo/BodyPartTwo';
import BodyShowVehicleInformation from '@/modules/adjusterReportModules/Insurer-information/components/vehicleInformation/components/showVehicleInformation/BodyShowVehicleInformation';
import BodyVehicleInformation from '@/modules/adjusterReportModules/Insurer-information/pages/vehicleInformation/BodyVehicleInformation';
import BodyExpert from '@/modules/adjusterReportModules/Insurer-information/pages/expert/BodyExpert';
import BodySubstitutionPartsFormPage from '@/modules/adjusterReportModules/Insurer-information/pages/expert/substitutionParts/BodySubstitutionPartsForm';
import BodySubstitutionPartsPage from '@/modules/adjusterReportModules/Insurer-information/pages/expert/substitutionParts/BodySubstitutionPartsPage';
import BodyVehicleShowVisitInformation from '@/modules/adjusterReportModules/Insurer-information/pages/expert/visitInformation/vehicle/BodyVehicleShowVisitInformation';
import BodyVehicleVisitInformation from '@/modules/adjusterReportModules/Insurer-information/pages/expert/visitInformation/vehicle/BodyVehicleVisitInformation';
import BodyWagesPage from '@/modules/adjusterReportModules/Insurer-information/pages/expert/wages/BodyWagesPage';
import BodyCostsPage from '@/modules/adjusterReportModules/Insurer-information/pages/expert/costs/BodyCostsPage';
import BodyShowCosts from '@/modules/adjusterReportModules/Insurer-information/pages/expert/costs/BodyShowCosts';
import InsurerInformation from '@/modules/adjusterReportModules/Insurer-information/pages/InsurerInformation';
import { ADJUSTER_REPORT_BODY_DAMAGE_PATHS } from '@/modules/adjusterReportModules/adjusterReport/links/bodyDamage/bodyDamageLinks';
import { Outlet, RouteObject } from 'react-router-dom';

const BODY_DRIVER_INFO_ROUTES: RouteObject[] = [
  {
    path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.DRIVER_OWNER.EDIT
      .driver,
    element: (
      <BodyDriverInfo>
        <Outlet />
      </BodyDriverInfo>
    ),
    children: [
      {
        element: <BodyInitialDataDriver />,
        index: true,
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.DRIVER_OWNER.EDIT
          .certificate,
        element: <BodyCertificateInformation />,
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.DRIVER_OWNER.EDIT
          .driverContact,
        element: <BodyContactInfo />,
      },
    ],
  },
  {
    path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.DRIVER_OWNER.EDIT.owner,
    element: (
      <BodyOwnerInfo>
        <Outlet />
      </BodyOwnerInfo>
    ),
    children: [
      {
        element: <BodyOwnerUserInformation />,
        index: true,
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.DRIVER_OWNER.EDIT
          .ownerContact,
        element: <BodyOwnerContract />,
      },
    ],
  },
  {
    path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.DRIVER_OWNER.show,
    element: <ShowBodyDriverOwnerData />,
  },
];

const BODY_VEHICLE_INFORMATION_ROUTES: RouteObject[] = [
  {
    path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.VEHICLE_INFORMATION.EDIT
      .base,
    element: (
      <BodyVehicleInformation>
        <Outlet />
      </BodyVehicleInformation>
    ),
    children: [
      {
        element: <BodyPartOne />,
        index: true,
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.VEHICLE_INFORMATION
          .EDIT.partTwo,
        element: <BodyPartTwo />,
      },
    ],
  },
  {
    path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.VEHICLE_INFORMATION
      .show,
    element: <BodyShowVehicleInformation />,
  },
];

const BODY_EXPERT_ROUTES: RouteObject[] = [
  {
    path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.EXPERT.base,
    children: [
      { index: true, element: <BodyExpert /> },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.EXPERT
          .substitutionParts,
        children: [
          { index: true, element: <BodySubstitutionPartsPage /> },
          {
            path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.EXPERT
              .substitutionPartsForm,
            element: <BodySubstitutionPartsFormPage />,
          },
        ],
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.EXPERT
          .substitutionPartsShow,
        element: <BodySubstitutionPartsPage isEditable={false} />,
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.EXPERT
          .visitInformation,
        element: <BodyVehicleVisitInformation />,
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.EXPERT
          .visitInformationShow,
        element: <BodyVehicleShowVisitInformation />,
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.EXPERT.wages,
        element: <BodyWagesPage />,
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.EXPERT.wagesShow,
        element: <BodyWagesPage isEditable={false} />,
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.EXPERT.costs,
        element: <BodyCostsPage />,
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.EXPERT.costsShow,
        element: <BodyShowCosts />,
      },
    ],
  },
];

const BODY_BANK_ACCOUNT_ROUTES: RouteObject[] = [
  {
    path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.BANK_ACCOUNT.edit,
    element: (
      <BankAccount>
        <Outlet />
      </BankAccount>
    ),
    children: [
      {
        element: <EditBodyBankAccount />,
        index: true,
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.BANK_ACCOUNT.show,
        element: <ShowBodyBankAccount />,
      },
    ],
  },
];

const BODY_INSURANCE_ROUTES: RouteObject[] = [
  {
    path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.PROPERTY_INSURANCE.edit,
    element: (
      <BodyInsuranceInsurance>
        <Outlet />
      </BodyInsuranceInsurance>
    ),
    children: [
      {
        element: <EditBodyInsurance />,
        index: true,
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.PROPERTY_INSURANCE
          .show,
        element: <ShowBodyInsurance />,
      },
    ],
  },
];

export const ADJUSTER_REPORT_BODY_DAMAGE_INFORMATION_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <InsurerInformation />,
  },
  ...BODY_DRIVER_INFO_ROUTES,
  ...BODY_INSURANCE_ROUTES,
  ...BODY_BANK_ACCOUNT_ROUTES,
  ...BODY_VEHICLE_INFORMATION_ROUTES,
  ...BODY_EXPERT_ROUTES,
];
